import { Component, OnInit, Input } from '@angular/core';
import { SearchCondition } from 'src/app/shared/model/search-condition.model';

@Component({
  selector: 'app-item-interview-times',
  templateUrl: './interview-times.component.html',
  styleUrls: ['./interview-times.component.scss']
})
export class InterviewTimesComponent implements OnInit {
  @Input() searchParams: SearchCondition;
  @Input() forWorker: boolean;
  @Input() open: boolean;

  constructor() {}

  ngOnInit() {}
}
